import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AuthenticationService } from '@core/services/authentication.serivce';

// telerik imports
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GridModule, ToolbarComponent } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, GridLayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { TextBoxModule, TextAreaModule, CheckBoxModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { NotificationModule } from '@progress/kendo-angular-notification';

import { SharedModule } from '@shared/shared.module';
import { HttpClient } from '@angular/common/http';

import { CheckoutsRoutingModule } from './checouts-routing.module';
import { CheckoutComponent } from './checkout/checkout.component';
import { ToolbarListComponent } from '../../shared/components/tool-bar/tool-bar.component';
import { SelectFieldComponent } from '../../shared/components/select-field/select-field.component';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ListBoxComponent } from '../../shared/components/list-box/list-box.component';
import { ListBoxModule } from '@progress/kendo-angular-listbox';


@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    LayoutModule,
    TextBoxModule,
    TextAreaModule,
    CheckBoxModule,
    ListBoxModule,
    IndicatorsModule,
    NumericTextBoxModule,
    DatePickerModule,
    LabelModule,
    GridLayoutModule,
    GridModule,
    DialogModule,
    InputsModule,
    SelectFieldComponent,
    ToolbarListComponent,
    ListBoxComponent,
    FaIconComponent,
    TabStripModule,
    CheckoutsRoutingModule
  ],
  declarations: [
    CheckoutComponent
  ],
  providers: [AuthenticationService]
})
export class CheckoutsModule { }
